module.exports = __webpack_public_path__ + "img/dashboard_avrg_value.f9515749.svg";